export function encodeFormData(data) {
  const formatted = [];

  Object.keys(data).forEach((key) => {
    const name = encodeURIComponent(key);
    const value = encodeURIComponent(data[key]);
    formatted.push(`${name}=${value}`);
  });

  return formatted.join('&').replace(/%20/g, '+');
}
